import {h} from 'preact'
import InputGroup from '../ui-components/InputGroup'
import Textarea from '../ui-components/Textarea'
import ButtonControl from '../button-control'
import AbstractProvider, {ProvidedItems} from "./AbstractProvider";
import {Configuration, Provider} from "./types";

interface Props {
  provider: Provider
  onMount: () => Promise<any>
  onSubmit: (configuration: Configuration) => void,
  toggleProviderVisibility: (provider: Provider) => void
}

const TokenSetup = (props: Props) =>
    <AbstractProvider {...props}>
      {({configuration, onSubmit, getError, getSubmitButtonProps, onInputChange} : ProvidedItems) =>
          <div className='form-enumeration'>
            <div className='form-enumeration__number'>1</div>
            <div className='form-enumeration__step-title'>Provide Token information</div>
            <div/>
            <div className='form-enumeration__step-content'>
              <p>Once you fill in these details and press 'Save changes', users on the community will be able to
                login using SSO, given all the information is provided is correct.</p>
              <form onSubmit={onSubmit}>
                <div>
                  {props.provider.fields.map(field => {
                    const error = getError(field.name)
                    return field.name == 'public_key' &&
                      <div className='form-group'>
                        <label>{field.label}</label>
                        <Textarea
                          value={configuration[field.name]}
                          onContentChange={(value: string) => onInputChange(field.name, value)}
                          class={`form-control ${error ? 'validation-error' : ''}`}
                        />
                        {error &&
                        <div className='validation-error error-message'>{error}</div>}
                      </div> ||
                      <InputGroup
                        title={field.label}
                        type='text'
                        value={configuration[field.name]}
                        onChangeCallback={(e: ChangeEvent) => onInputChange(field.name, e.target.value)}
                        error={getError(field.name) || undefined}
                      />
                  })}
                </div>
                <div>
                  <ButtonControl {...getSubmitButtonProps()} />
                  <ButtonControl
                      title='Cancel'
                      variant='secondary'
                      onClick={() => window.location.assign('/integration/sso')}
                  />
                </div>
              </form>
            </div>
          </div>
      }
    </AbstractProvider>

export default TokenSetup
